module.exports = __webpack_public_path__ + "img/pl3_icon.e89811fb.png";